// extracted by mini-css-extract-plugin
export default {"addRow":"AddRoomModal_addRow__ehXqB","rowInnerBtn":"AddRoomModal_rowInnerBtn__TYVGP"};